import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import { useLocation } from 'react-router-dom';
import { isWebviewRenderType } from 'Utils/webviewMode';

const WorldCupNostalgia = loadable(() => import('./WorldCupNostalgia'), {
  fallback: <Loading />
});

const getSearchParam = (search, name) => {
  const params = new URLSearchParams(search || '');
  const target = name.toLowerCase();
  for (const [key, value] of params.entries()) {
    if (key.toLowerCase() === target) {
      return value;
    }
  }
  return null;
};

const AsyncWorldCupNostalgia = props => {
  const location = useLocation();
  const channelRaw = getSearchParam(location.search, 'channel');
  const channel = channelRaw ? channelRaw.toLowerCase() : undefined;
  const isNativeAppChannel = channel === 'ios' || channel === 'android';
  const isWebView = isNativeAppChannel
    || (isWebviewRenderType(location.search) && props.userAgent.device?.type === 'mobile');

  const pageConfig = {
    headerType: isWebView ? 'mobile-none' : 'full',
    footerType: isWebView ? 'none' : 'full',
    helmet: {
      bodyAttributes: {
        class: `${props.userAgent.device?.type} ${isWebView ? 'hide-betslip hide-sticky-navigation world-cup-nostalgia-body' : 'bg-smoke-grey'}`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <WorldCupNostalgia { ...props } isWebView={ isWebView } channel={ channel } />
    </ApplicationLayout>
  );
};

AsyncWorldCupNostalgia.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncWorldCupNostalgia;
